module.exports = __webpack_public_path__ + "assets/img/swiper-3-7.7d2a9d80.jpg";